import { Icon, Button } from '@genial/components';
import { Color, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Pressable } from 'native-base';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { useHomeActions } from '../../../../../../store/home/capture/actions';
import { getHomeValueVisibility } from '../../../../../../store/home/capture/selector';

interface ValueDisplayToggleProps {
  isMobile?: boolean;
  color?: string;
}

export const ValueDisplayToggle: React.FC<ValueDisplayToggleProps> = ({ isMobile, color }) => {
  const visible = useRecoilValue(getHomeValueVisibility);
  const { updateHomeValueVisibility } = useHomeActions();
  const iconSize = useBreakpointValue({
    base: 'sm',
    sm: 'xs',
  });
  const iconVariant = useBreakpointValue({
    base: 'default',
    sm: 'rounded',
  });

  const iconName = visible ? 'VisibilityOff' : 'Visibility';
  const handlePress = () => updateHomeValueVisibility(!visible);
  const icon = (
    <Icon
      name={iconName}
      size={iconSize}
      testId="right-icon"
      variant={iconVariant}
      color={color}
      backgroundColor={visible ? Color['neutral.light'] : Color['brand.tertiary.principal']}
    />
  );

  if (isMobile) {
    return <Pressable onPress={handlePress}>{icon}</Pressable>;
  } else {
    return (
      <Button
        testID="button"
        variant="secondary"
        rightIcon={icon}
        shadow={1}
        onPress={handlePress}
        _text={{
          fontFamily: Typography['fontfamily.base.semibold'],
        }}>
        {visible ? 'ESCONDER VALORES' : 'EXIBIR VALORES'}
      </Button>
    );
  }
};
